export default {
  optOutHint: {
    title: 'Gilt für alle künftigen Versionen',
    availability: 'Qmulus öffnet die Neuerungen nach Updates nicht mehr. Sie bleiben jederzeit verfügbar:',
    versionNumber: 'Versionsnummer im Benutzermenü',
    showAgain: 'Um sie nach Updates wieder anzuzeigen, wählen Sie {location}.',
  },
};
